import {ActivatedRoute, Router} from '@angular/router';
import { BDUtilityService} from '@brother-apps/brother-dealerapp-shared-lib';
import {Component, OnInit} from '@angular/core';

import {BDCPConstsService} from '../../../shared/services/consts.service';
import {BDCPProductDetails} from '../../../../models/product-details.model';
import {BDCPShareService} from '../../../shared/services/share.service';
import {IBDCPFolderService} from '../../../shared/services/folder-service/folder.interface';
import {IBDCPProductsService} from '../../../shared/services/products-service/products.interface';
import {Location} from '@angular/common';

@Component({
    selector: 'bdcp-product-details-root',
    templateUrl: './root.page.html',
    styleUrls: ['./root.page.scss']
})
export class BDCPProductDetailsRootComponent implements OnInit {

    public product: BDCPProductDetails;

    public initialized: boolean;

    public pseudoSupplies: any[];
    public pseudoAccessories: any[];

    public constructor(
        public folderService: IBDCPFolderService,
        public consts: BDCPConstsService,
        public share: BDCPShareService,
        private location: Location,
        private route: ActivatedRoute,
        private router: Router,
        private productsService: IBDCPProductsService,
        private utility: BDUtilityService
    ) {
    }

    public ngOnInit(): void {
        this.initialized = false;



        this.route.params.subscribe(async params => {
            await this.init(params['sku']);

            this.initialized = true;
        });
    }

    public back(): void {
        this.location.back();
    }

    public async navigateToBookmarks() {
        await this.router.navigate([  '/products', 'bookmarks']);
    }

    public async navigateToProductDetails(sku: string) {
        await this.router.navigate(['/products', 'product-details', sku]);
    }

    public requestCallback(): void {
        window.location.href = this.utility.requestCallback(
            this.share.sharedModel.name,
            this.share.sharedModel.firstname,
            this.share.sharedModel.email,
            this.share.sharedModel.salutation,
            'presales-solutions@brother.de',
            'Sales App: Presales-Anfrage '
        );
    }

    public requestProject(): void {
        // web
        window.open('https://secure.brother.de/portal/index.cfm?pos=prj3', 'blank');
        // iOS
        // window.location.href = 'https://secure.brother.de/portal/index.cfm?pos=prj3';
    }

    public getBackText(): string {
        if (this.share.visitedPages.length < 3) {
            return 'Zurück zur Ergebnisliste';
        }
        return this.share.visitedPages[this.share.visitedPages.length - 3] === '/products/bookmarks/details/:folderId/'
            ? 'Zurück'
            : 'Zurück zur Ergebnisliste';
    }

    private async init(sku: string): Promise<void> {
        try {
            this.product = await this.productsService.getDetails(sku);
        } catch (ex) {

        }

        this.pseudoSupplies = Array(!(this.product && this.product.supplies)
            ? 0
            : 3 - (this.product.supplies.length % 3)).fill(0);

        this.pseudoAccessories = Array(!(this.product && this.product.accessories)
            ? 0
            : 3 - (this.product.accessories.length % 3)).fill(0);
    }

    onImageError(event: Event): void {
        const target = event.target as HTMLImageElement;
        target.src = 'assets/images/product_img_dummy.png';
    }
}
